export const locale = {
    lang: 'en',
    data: {
        'Header': {
            "Title": "Copy Material Details"
        },
        "FIELDS": {
            "MaterialNumber": "Material Number",
            "Barcode": "Barcode"
        },
        "BUTTONS": {
            "Add": "Add"
        },
        "MESSAGES": {
            'Updated': 'Updated Successfully.',
            'Failed': 'Failed',
            'Deleted': 'Deleted successfully',
            "NORECORD": "No Record Found"
        }
    }
}